import { Route } from 'react-router'
import { personalizationPerIdPath } from 'app/navigation/paths'
import CustomSwitch from 'app/router/Switch'

import ExperimentReport from './experimentsPage/ExperimentReport'
import ExperimentsPage from './experimentsPage'

const Personalization = () => {
  return (
    <div className="flex flex-col h-full w-full relative bg-coolGray-100 overflow-y-auto">
      <CustomSwitch>
        <Route key="view-experiments" path="/personalization" exact>
          <ExperimentsPage />
        </Route>
        <Route key="view-experiment" path={personalizationPerIdPath}>
          <ExperimentReport />
        </Route>
      </CustomSwitch>
    </div>
  )
}

export default Personalization
